(function () {
  try {    
    function waitForElement(selector, trigger) {
      var interval = setInterval(function() {
        if (document && document.querySelector(selector) && document.querySelectorAll(selector).length > 0) {
          clearInterval(interval);
          trigger();
        }
      }, 50);
      setTimeout(function() {
        clearInterval(interval);
      }, 30000);
    }

    function waitForSwiper(trigger) {
      var interval = setInterval(function () {
        if(typeof Swiper !== "undefined") {
          clearInterval(interval);
          trigger();
        }
      }, 50);
      setTimeout(function () {
        clearInterval(interval);
      }, 15000);
    }

    function debounce(func, delay) {
      let timeout;
      return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), delay);
      };
    }

    function live(selector, event, callback, context = document) {
      const addEvent = (el, type, handler) => {
        el.addEventListener(type, handler);
      };
      const liveHandler = e => {
        const el = e.target && e.target.closest ? e.target.closest(selector) : null;
        if (el && el !== context) {
          callback.call(el, e);
        }
      };
      addEvent(context, event, liveHandler);
    }

    function addColorName() {
      var selectedValue = document.querySelector('.product .main-product .swatchContainer input.inputColor:checked ~ .infoColorc');
      var colorTitle = document.querySelector('.product .main-product .swatchComponent > .form__label');
      if(!selectedValue || !colorTitle) return;

      if(!document.querySelector('.bm-pdp02-color-label-container')) {
        colorTitle.insertAdjacentHTML('beforebegin', `<div class="bm-pdp02-color-label-container">Color : <span class="bm-pdp02-color-label">${selectedValue.textContent.trim()}</span></div>`);
      }
    }

    function extractParts(text) {
      // Remove extra spaces
      text = text.trim();

      // 1. Extract currency prefix
      // Example: "£40.00GBP" → "£"
      var prefixMatch = text.match(/^[^\d]+/);
      var prefix = prefixMatch ? prefixMatch[0] : '';
    
      // 2. Extract currency suffix
      // Example: "£40.00GBP" → "GBP"
      var suffixMatch = text.match(/[^\d.,]+$/);
      var suffix = suffixMatch ? suffixMatch[0] : '';
    
      // 3. Extract numeric portion
      // Example: "£40.00GBP" → "40.00"
      var numberMatch = text.match(/[\d.,]+/);
      var number = numberMatch ? numberMatch[0] : '';
    
      // Remove existing commas before parsing
      var value = parseFloat(number.replace(/,/g, ''));
    
      // If number parsing fails, stop
      if (isNaN(value)) return null;
    
      return {
        value: value,     // Numeric value (6600)
        prefix: prefix,   // Currency symbol/text before number
        suffix: suffix    // Currency code/text after number
      };
    }    

    function updatePriceHtml() {
      // Get sale price container
      var priceHtml = document.querySelector('.product .main-product .price.price--on-sale');
      if (!priceHtml) return;
    
      priceHtml.classList.add('bm-pdp02-price-updated');
    
      // Get sale & regular price elements
      var salePrice = priceHtml.querySelector('.price-item--sale');
      var regularPrice = priceHtml.querySelector('.price-item--regular .percent-price-item');
    
      // Remove "Now" label
      if (salePrice) {
        salePrice.innerText = salePrice.innerText.replace("Now ", "");
    
        // Remove pipe separator
        if (salePrice.nextSibling && salePrice.nextSibling.textContent.includes("|")) {
          salePrice.nextSibling.remove();
        }
      }
    
      // Remove "Was" label
      if (regularPrice) {
        regularPrice.innerText = regularPrice.innerText.replace("Was ", "");
      }
    
      if (!salePrice || !regularPrice) return;
    
      // Extract price parts (value, prefix, suffix)
      var saleData = extractParts(salePrice.textContent);
      var regularData = extractParts(regularPrice.textContent);
    
      if (!saleData || !regularData) return;
    
      // Calculate numeric savings
      var savingsValue = regularData.value - saleData.value;
      if (savingsValue <= 0) return;
    
      // Format with comma separator (6,600.00)
      var formattedSavings = savingsValue.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    
      var priceItemRegular = priceHtml.querySelector('span > .price-item--regular');
      if (!priceItemRegular) return;
    
      var wrapperSpan = priceItemRegular.closest('span');
      if (!wrapperSpan) return;
    
      // Build final save text
      var saveText = `You Save ${saleData.prefix}${formattedSavings}${saleData.suffix}`;
      var existingSaveEl = document.querySelector('.bm-pdp02-save-price');
    
      // Insert or update save amount
      if (!existingSaveEl) {
        wrapperSpan.insertAdjacentHTML(
          'afterend',
          `<span class="bm-pdp02-save-price">${saveText}</span>`
        );
      } else {
        existingSaveEl.innerText = saveText;
      }
    }
    
     

    function sliderInitialize() {
      var swiper = new Swiper('.bm-pdp02-media-gallery-slider', {
        slidesPerView: 1.17,
        spaceBetween: 3,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }

    function updateMediaGallery() {
      var existingGallery = document.querySelector('.bm-pdp02-media-gallery');
      var targetPosition = document.querySelector('.product media-gallery');
      var activeImages = document.querySelectorAll('.product .product__media-list li.product__media-item[style="display: block;"] img');
      if(activeImages.length === 0) {
        activeImages = document.querySelectorAll('.product .product__media-list li.product__media-item img');
      }

      existingGallery && existingGallery.remove();
      if(!activeImages || activeImages.length === 0 || !targetPosition) return;

      var newMediaGallery = `
      <div class="bm-pdp02-media-gallery">
        <div class="bm-pdp02-media-gallery-wrapper">
          <div class="swiper bm-pdp02-media-gallery-slider">
            <div class="swiper-wrapper">
              ${Array.from(activeImages).map((image) => `
                <div class="swiper-slide bm-pdp02-media-gallery-slide">
                  <div class="bm-pdp02-media-gallery-slide-inner">
                    <img class="bm-pdp02-media-gallery-slide-image" src=${image.src} alt=${image.alt}>
                  </div>
                </div>
              `).join('')}
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>`;

      targetPosition.insertAdjacentHTML("beforebegin", newMediaGallery);
      sliderInitialize();
    }

    // reposition pcode and item code
    function repositionProductItemCode() {
      const itemCode = document.querySelector('.product .main-product .item-code-sku');
      const accordionContent = document.querySelector('.product .main-product #description .accordion__content');
      
      if (!itemCode || !accordionContent) return;

      if(document.querySelector('.bm-pdp02-item-code')) {
        document.querySelector('.bm-pdp02-item-code').remove();
      }
      
      accordionContent.insertAdjacentHTML('beforeend', `<span class="bm-pdp02-item-code">${itemCode.outerHTML}</span>`);
      itemCode.classList.add('bm-pdp02-item-cloned');
    }

    /* ------------------------------
       Initialize Variation
    ------------------------------ */
    initializeVariation();
    window.addEventListener('resize', debounce(initializeVariation, 100));

    function initializeVariation() {
      console.log('>> Initialize Variation');
      if (window.location.pathname.includes("/products/") && window.innerWidth < 750) {
        waitForElement('body', function(){
          document.body.classList.add('bm-pdp02');
          waitForElement('.product .main-product .swatchContainer input.inputColor:checked ~ .infoColorc', addColorName);
          waitForElement('.product .main-product .price.price--on-sale', updatePriceHtml);
        });
  
        // Insert new media gallery carousel
        waitForElement('.product .product__media-list li.product__media-item[style="display: block;"] img', function (){
          waitForSwiper(updateMediaGallery);
        });
        waitForElement('.product .product__media-list li.product__media-item img', function (){
          waitForSwiper(updateMediaGallery);
        });
  
        // replace pcode and item code
        waitForElement('.product .main-product product-info .item-code-sku, .product .main-product #description .accordion__content', function() {
          setTimeout(repositionProductItemCode, 2000);
        });
      } else {
        document.body.classList.remove('bm-pdp02');
      }
    }

    /* ------------------------------
       Event Handlers
    ------------------------------ */
    if (!window.pdp02firstFoldTest) {
      window.pdp02firstFoldTest = true;

      // Change in color swatch
      live('.product .main-product .swatchContainer input.inputColor', 'change', function() {
        var selectedValue = document.querySelector('.product .main-product .swatchContainer input.inputColor:checked ~ .infoColorc');
        var colorLabel = document.querySelector('.bm-pdp02-color-label');
        if(selectedValue && colorLabel) {
          colorLabel.textContent = selectedValue.textContent.trim();
        }

        // Update price for variant
        waitForElement('.product .main-product .price.price--large.price--on-sale:not(.bm-pdp02-price-updated)', updatePriceHtml);

        // Update media gallery
        waitForSwiper(updateMediaGallery);

        // reposition pcode and item code
        waitForElement('.product .main-product .item-code-sku:not(.bm-pdp02-item-cloned)', function(){
          setTimeout(repositionProductItemCode, 2000);
        });
      });

      live('.product .main-product variant-radios > .product-form__input input.opt__size', 'change', function() {
        // Update price for variant
        waitForElement('.product .main-product .price.price--large.price--on-sale:not(.bm-pdp02-price-updated)', updatePriceHtml);

        // reposition pcode and item code
        waitForElement('.product .main-product .item-code-sku:not(.bm-pdp02-item-cloned)', function(){
          setTimeout(repositionProductItemCode, 2000);
        });
      });
    }

  } catch (e) {
    console.log(e, "error in Test PDP First Fold Test [mobile only]");
  }
})();